// extracted by mini-css-extract-plugin
module.exports = {"subtext_exchange":"FreeTrial_subtext_exchange__2_r-r","button_style":"FreeTrial_button_style__3kOns","office_label":"FreeTrial_office_label__CoSxh"};